export const environment = {
  production: true,
  hubUrl: '',
  apiUrl: '',
  brokerURL: '',
  hydrateStore: false,
  shouldRemoveMHPermissions: false
};
